import Vue from 'vue'
import { API_URL } from '../../api'
import PlansFilter from '../../filters/PlansFilter';
const state = {
    planCreate: {
        createdPlan: null,
        creatingPlan: false,
        createPlanStatus: null
    },
    planUpdate: {
        updatedPlan: null,
        updatingPlan: false,
        updatePlanStatus: null
    },
    planDelete: {
        deletingPlan: false,
        deletePlanStatus: null
    },
    planSearch: {
        plansCount: null,
        plansPaginated: [],
        plans: [],
        searchingPlans: false,
        searchPlanStatus: null
    },
    planPerformanceSearch: {
        plansPerformance: [],
        searchingPlansPerformance: false,
        searchPlanPerformanceStatus: null
    },
}
const mutations = {
    ['SET_PLAN_CREATE'](state, change) {
        state.planCreate = { ...state.planCreate, ...change };
    },
    ['SET_PLAN_UPDATE'](state, change) {
        state.planUpdate = { ...state.planUpdate, ...change };
    },
    ['SET_PLAN_DELETE'](state, change) {
        state.planDelete = { ...state.planDelete, ...change };
    },
    ['SET_PLAN_SEARCH'](state, change) {
        state.planSearch = { ...state.planSearch, ...change };
    },
    ['SET_PLAN_PERFORMANCE_SEARCH'](state, change) {
        state.planPerformanceSearch = { ...state.planPerformanceSearch, ...change };
    }

}
const actions = {
    createPlan: ({ commit }, payload) => {
        commit('SET_PLAN_CREATE', { createPlanStatus: null, createdPlan: null, creatingPlan: true })
        return Vue.http.post(API_URL + '/plans/create', payload).then(response => {
            commit('SET_PLAN_CREATE', { createPlanStatus: 'success', createdPlan: response.body.results.plan });
        }).catch(response => {
            commit('SET_PLAN_CREATE', { createPlanStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_CREATE', { creatingPlan: false });
        });
    },
    updatePlan: ({ commit }, payload) => {
        commit('SET_PLAN_UPDATE', { updatePlanStatus: null, updatedPlan: null, updatingPlan: true })
        return Vue.http.post(API_URL + '/plans/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PLAN_UPDATE', { updatePlanStatus: 'success', updatedPlan: response.body.results.plan });
            })
            .catch(response => {
                commit('SET_PLAN_UPDATE', { updatePlanStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PLAN_UPDATE', { updatingPlan: false });
            })
    },
    deletePlan: ({ commit }, id) => {
        commit('SET_PLAN_DELETE', { deletePlanStatus: null, deletedPlan: null, deletingPlan: true })
        return Vue.http.delete(API_URL + '/plans/delete/' + id).then(response => {
            commit('SET_PLAN_DELETE', { deletePlanStatus: 'success' });
        }).catch(response => {
            commit('SET_PLAN_DELETE', { deletePlanStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_DELETE', { deletingPlan: false });
        })
    },
    searchPlans: ({ commit }, payload = { filter: PlansFilter(), resultMode: 'default' }) => {
        commit('SET_PLAN_SEARCH', { searchPlanStatus: null, searchPlan: null, searchingPlans: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/plans' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_PLAN_SEARCH', { searchPlanStatus: 'success', plansCount: response.body.results.plans });

            } else if (payload.resultMode == 2) {
                commit('SET_PLAN_SEARCH', { searchPlanStatus: 'success', plansPaginated: response.body.results.plans });

            } else {
                commit('SET_PLAN_SEARCH', { searchPlanStatus: 'success', plans: response.body.results.plans });
            }
        }).catch(response => {
            commit('SET_PLAN_SEARCH', { searchPlanStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_SEARCH', { searchingPlans: false });
        })
    },
    searchPlansPerformance: ({ commit }, payload) => {
        commit('SET_PLAN_PERFORMANCE_SEARCH', { searchPlansPerformanceStatus: null, searchPlansPerformance: null, searchingPlansPerformance: true })
        return Vue.http.post(API_URL + '/plans-performance', payload).then(response => {
            commit('SET_PLAN_PERFORMANCE_SEARCH', { searchPlansPerformanceStatus: 'success', plansPerformance: response.body.results.plansPerformance });
        }).catch(response => {
            commit('SET_PLAN_PERFORMANCE_SEARCH', { searchPlansPerformanceStatus: 'failed' });
        }).finally(() => {
            commit('SET_PLAN_PERFORMANCE_SEARCH', { searchingPlansPerformance: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/planStore.js